import { Color } from '@models/authentication/enums/color.enum';

export class AppColor {
  color: Color;
  base: string;
  light: string;
  dark: string;

  constructor(color: Color, base: string, light: string, dark: string) {
    this.color = color;
    this.base = base;
    this.light = light;
    this.dark = dark;
  }

  compareWith(color: AppColor): boolean {
    return this.base === color.base && this.light === color.light && this.dark === color.dark;
  }
}
